import { IApplicationState } from '../../../types';
import { getPublicState } from '../../selectors';
import { LandingPageState } from '../reducer';

export const getLandingPageState = (
  state: IApplicationState,
): LandingPageState => getPublicState(state).landing;
